module.exports = __webpack_public_path__ + "img/1f432.7ef2f07.svg";